module.exports = __webpack_public_path__ + "media/newstyle/images/stars_5-df376960c148be219f788eac79a64a12.svg";